// console.log("roof-calculator-Axiome-Snapa");
var tag1 = "";
var tag2 = "Axiome 10mm Clear Roof Calc";
var tag3 = "Alukap-XR Roof Calc";
var rfnm = 1;
var collection1 = 0;
var collection2 = 0;
var lntha = 0;
var lnthb = 0;
var lnthc = 0;
var maxlen = 0;
var double = 1;
var quantity = 1;
var sheets = 1;
var clrcart = 0;
var products = [];
var products1 = [];
var products2 = [];
var colours1 = [];
var colours2 = [];
var colour1 = 'Clear';
var colour2 = 'White';
var mycart = [];
var newcart = [];
var mcaheaders = {method: 'get', headers: new Headers({'Authorization': 'Token 56e79298c2a7bf646d367522b3e2350ee6841de1','Content-Type': 'application/x-www-form-urlencoded'})};
var apiurl = 'https://myclearamber.com/mycapi/v1/cashop/';
if("cas.grokurv.co.uk" == window.location.hostname){
  var apiurl = 'https://myclearamber.com/mycapi/v1/cashopDev/';
}

$(".roofcal .roofimg").click(function(){
  	tag1 = $(this).attr('title');
  	rfnm = $(this).attr('key');
    var image = $(this).find('img').attr('src');
    var img = tag1.replaceAll('– ','');
    img = img.replaceAll(' ','_')+"_"+rfnm;
    image = image.replace(img,"Axiome_"+img+"_"+colour1);
    // image = "Axiome_"+img+"_"+colour1;
    // console.log(image,img, rfnm);
  	$('.rooftype, .roofsize').hide();
  	$('.roofsheet').show();
  	$('.roofsheet img').attr('src',image);
  	$('.roofsheet img').attr('key',$(this).find('img').attr('src'));
  	$('.roofsize img').attr('src',image);
  	$('.roofsize img').attr('key',$(this).find('img').attr('src'));
  	collection11();
  	collection22();
    $('select[name="colour1"]').val('Clear').trigger('change');
  	$(".roofcal .number").removeClass("current").removeClass("complete");
  	$(".roofcal .number.wtor").addClass("complete");
  	$(".roofcal .number.yrc").addClass("current");
});

$(".roofcal .yrc").click(function(){
  	if(tag1 == ''){
    	return false;
    }
  	$('.rooftype, .roofsize').hide();
  	$('.roofsheet').show();
	$(".roofcal .number").removeClass("current").removeClass("complete");
  	$(".roofcal .number.wtor").addClass("complete");
  	$(".roofcal .number.yrc").addClass("current");
})

$('.crs').change(function(){
  	tag2 = $(this).val();
  	collection11();
})

function collection11(){
  	var colfltr = tag1+" || "+tag2;
  	var tags = fetch(apiurl+"products/?ctag="+colfltr, mcaheaders)
      .then(response => response.json())
      .then(data => {
        				collection1 = data['results'][0];
        				products1 = data['results'];
        				cproducts(data['results'], 1);
        				return data 
                    });
}

$('.thickness').change(function(){
  	// tag3 = $(this).val();
    tag2 = 'Axiome '+$(this).val()+' '+colour1+' Roof Calc';
  	collection11();
})

function collection22(){
	var colfltr = tag1+" || "+tag3;
  	var tags = fetch(apiurl+"products/?ctag="+colfltr, mcaheaders)
      .then(response => response.json())
      .then(data => {
        				collection2 = data['results'][0];
        				products2 = data['results'];
        				cproducts(products2, 2);
        				return data 
                    });
}

$('select[name="colour1"]').change(function(){
  	clearCart();
  	newcart = [];
  	colour1 = $(this).val();
  	colour2 = $('select[name="colour2"]').val();
  	$('.roofselect button').attr('disabled',false);
	$('.products .tag1 select[name="COLOUR"]').val(colour1);
  	$('.products .tag1 select[name="COLOUR"]').attr('disabled','disabled');
  	var img = tag1.replaceAll('– ','');
  	img = img.replaceAll(' ','_')+"_"+rfnm;
  	var crtimg = $(".roofsheet img").attr("key");
  	$(".roofsheet img, .roofsize img").attr("src",crtimg.replace(img,"Alukap-XR_"+img+"_"+colour1+"_"+colour2).replace('__','_'));
    tag2 = 'Axiome '+$('.thickness').val()+' '+colour1+' Roof Calc';
    collection11();
})

$('select[name="colour2"]').change(function(){
    colour1 = $('select[name="colour1"]').val();
  	colour2 = $(this).val();
	$('.products .tag2 select[name="COLOUR"]').val(colour2);
  	$('.products .tag2 select[name="COLOUR"]').attr('disabled','disabled');
    var img = tag1.replaceAll('– ','');
  	img = img.replaceAll(' ','_')+"_"+rfnm;
  	var crtimg = $(".roofsheet img").attr("key");
  	$(".roofsheet img, .roofsize img").attr("src",crtimg.replace(img,"Alukap-XR_"+img+"_"+colour1+"_"+colour2).replace('__','_'));
})

$('.rfsize').click(function(){
// 	console.log("Select Roof Size ", tag1, tag2, tag3);
    if(tag2 == ''){
      	alert("Please select Roof Sheet Type");
      	return false;
    }
  	if(tag3 == ''){
      	alert("Please select Colour of Glazing Bars");
    	return false;
    }
  	if(tag1 == 'Apex – Free Standing' || tag1 == 'Apex – Lean To'){
//     	$('.roofszc').show();
      	$('.roofszc').hide();
    }else{
    	$('.roofszc').hide();
    }
    if(colour1 == ''){
      alert("Please select Colours First?");
      return false;
    }
  	$('.rooftype').hide();
  	$('.roofsheet').hide();
  	$('.roofsize').show();
//   	$('.products').show();
  	
  	$(".roofcal .number").removeClass("current").removeClass("complete");
  	$(".roofcal .number.wtor, .roofcal .number.yrc").addClass("complete");
  	$(".roofcal .number.cyrs").addClass("current");
})

$('.srtype').click(function(){
	$('.rooftype').show();
  	$('.roofsheet').hide();
  	$('.roofsize').hide();
  	$('.products').html('').hide();
//   	$('input, select').val('');
  	$('.colour1, .colour2').hide();
  	
  	$(".roofcal .number").removeClass("current").removeClass("complete");
  	$(".roofcal .number.wtor").addClass("current");
})


function cproducts(pdata, tg){
	products = products.concat(pdata);
    if(tg == 1){
      variants(products1, tg);
      for(let i = 0; i < products1[0]['options'].length; i++){
        if(products1[0]['options'][i]['name']=='COLOUR'){
          colours1 = products1[0]['options'][i]['values'];
          clroption(colours1, 1);
        }
      }
    }
    if(tg == 2){
      variants(products2, tg);
      for(let i = 0; i < products2[0]['options'].length; i++){
        if(products2[0]['options'][i]['name']=='COLOUR'){
          colours2 = products2[0]['options'][i]['values'];
          clroption(colours2, 2);
        }
      }
    }
}

function variants(products, tg=1){
  	var allprod = '';
  	for(let i = 0; i < products.length; i++){
      	var options = '';
      	var optcls = '';
      	var ttl = '';
      	var tgstr = JSON.stringify(products[i]['tags']);
      	for(let j = 0; j < products[i]['options'].length; j++){
          drp = '';
          optcls = optcls+' '+products[i]['options'][j]['name'];
          for(let k = 0; k < products[i]['options'][j]['values'].length; k++){
          	drp += '<option>'+products[i]['options'][j]['values'][k].replaceAll("m","")+'</option>';
          }
          options += '<div>'+products[i]['options'][j]['name']+' <select name="'+products[i]['options'][j]['name']+'">'+drp+'</select> </div>';
      	}
      	if(products[i]['tags'].indexOf('PRODUCT') > 0){ ttl = products[i]['tags'].substring(products[i]['tags'].indexOf('PRODUCT'), products[i]['tags'].indexOf('PRODUCT')+9) }
      	allprod +='<div class="w-100 tag'+tg+' '+ttl.replace(' ','')+' prod'+products[i]['id']+' option'+products[i]['options'].length+' '+optcls+' "><div class="w-20 image"> <img src="'+products[i]['images'][0]['src']+'" alt="'+products[i]['title']+'" title="'+ttl+'"></div><div class="w-20">'+products[i]['title']+'</div><div class="w-20">'+options+'</div><div class="w-20"><input type="number" class="quantity" value="1"></div><div class="w-20 total"></div></div>';
    }
  	$('.products').append(allprod);
}

function clroption(colours, tg){
  if(tg == 1){
    var nclr = '<option value="">-- Select Colour --</option>';
    for(let i=0; i< colours.length; i++){
//     	$('select[name="colour1"]').append('<option>'+colours[i]+'</option>');
      nclr += '<option>'+colours[i]+'</option>';
    }
    $('select[name="colour1"]').html(nclr);
    $('select[name="colour1"]').show();
  }
  if(tg == 2){
    // $('select[name="colour2"]').html('<option value="White">-- Select Glazing Bar Colour --</option>');
    // colour2 = colours[0];
    // for(let i=0; i< colours.length; i++){
    // 	$('select[name="colour2"]').append('<option>'+colours[i]+'</option>');
    // }
    // $('select[name="colour2"]').show();
    if(tag2 == 'Corrapol-BT Sheets'){
      $('select[name="colour2"]').hide();
    }
  }
}


$('.ckit').click(function(){
  	$(this).attr("disabled","disabled");
  	clearCart();
  	$('.products .total').html('');
    maxlen = parseInt(products1[0]['options'][1]['values'].at(-1).replace('mm',''));
    maxlen = 6000;
  	lntha = parseInt($('.roofinput input[name="lengtha"]').val());
  	lnthb = parseInt($('.roofinput input[name="lengthb"]').val());
  	if(lntha < 99 || lnthb < 99){
    	alert("Please enter the valid length and width");
        $(this).attr("disabled",false);
      	return false;
    }
    if(lnthb > maxlen){
      alert("This size is too long, please get free advice on Live Chat");
      $(this).attr("disabled",false);
      return false;
    }
  	for(let i = 0; i < products.length; i++){
    	if(products[i]['options'].length == 1){
          quantitycal(products[i], i);
        }
    }
  	lengthCal(products2);
  	updateCart();
})


function quantitycal(prdt, index){
//   console.log("Quantity ", prdt, lntha, lnthb);
  var lengthq = 1;
  var widthq = 1;
  if(lntha > 950){
//     lntha -= 100;
    lengthq = parseInt((lntha-100)/850)+1;
  }
  if(lnthb > 2000){
//     lnthb -= 150;
    widthq = parseInt((lnthb-150)/1850)+1;
  }
  quantity = lengthq*widthq;
  $('.products .option1 .quantity').val(quantity*double);		// Fill the Quantity
  $('.products .PACK .quantity').val(quantity*double*2);		// Fill the pack quantity
  return quantity*double;
}

function lengthacal(){
	var lengthq = 1;
  	if(lntha > 950){
//       lntha -= 100;
      lengthq = parseInt((lntha-100)/850)+1;
    }
  return lengthq;
}
function lengthbcal(newb,ltb){
	var widthq = 1;
  	if(newb > ltb){
//       lnthb -= 150;
      widthq = parseInt((newb-150)/(ltb-150))+1;
    }
  return widthq;
}

function updateCart(){
    console.log("New Cart Items =", newcart);

  function sortProducts(data) {
    return data.sort((a, b) => {
      const numA = parseInt(a.sno.replace("PRODUCT", ""), 10);
      const numB = parseInt(b.sno.replace("PRODUCT", ""), 10);
      return numA - numB;
    });
  }
  const sortedData = sortProducts(newcart);
    // Add Product to Cart
    var citems = [];
    for(let c=0; c<sortedData.length; c++){
      if (JSON.stringify(citems).indexOf(sortedData[c]['variant']) > 0){
        for (let v = 0; v < citems.length; v++) {
          if (citems[v]['id']) { citems[v]['quantity'] = citems[v]['quantity']+sortedData[c]['quantity']; }
        }
      }else{
        citems.push({"quantity":sortedData[c]['quantity'], "id":sortedData[c]['variant'], properties: {"ROOF TYPE": tag1, "COLOUR":colour1, "LENGTH A":lntha, "LENGTH B":lnthb, "PRODUCT":sortedData[c]['sno'] }});
      }
      // citems.push({"quantity":newcart[c]['quantity'], "id":newcart[c]['variant'], properties: {"ROOF TYPE": tag1, "COLOUR":colour1, "LENGTH A":lntha, "LENGTH B":lnthb, "PRODUCT":newcart[c]['sno']}});
    }
    console.log(citems);
 
//   	jQuery.post('/cart/add.js', {
//         items: citems
//       }).then(data => {
//         $(".ckit").attr("disabled",false);
//         window.location.href = '/cart';
//       });
    citems.reverse();

    myInterval = setInterval(function () {
      if(clrcart == 0){
        jQuery.post('/cart/add.js', {
          items: citems
        }).then(data => {
          $(".ckit").attr("disabled",false);
          if(window.location.pathname.indexOf('fr-fr') == 1){ window.location.href = '/fr-fr/cart'; }else{ window.location.href = '/cart'; }
        });
        clearInterval(myInterval);
      }else{
          // console.log(clrcart);
      }
    }, 500);
}

function lengthCal(prod){
  var apex = 1;
  if(tag1 == 'Apex – Free Standing' || tag1 == 'Apex – Lean To'){ apex = 2; }
  for(let p=0; p<products1.length; p++){
    let noptions = products1[p]['options'][0]['values'].toString().replaceAll('m','').replaceAll(' ','').split(',').sort();
  	noptions = noptions.map(function(element) { if(element > 20){ return parseInt(element); } return parseInt(element)*1000; }).sort((a, b) => a - b);
    let boptions = products1[p]['options'][1]['values'].toString().replaceAll('m','').replaceAll(' ','').split(',').sort();
  	boptions = boptions.map(function(element) { if(element > 20){ return parseInt(element); } return parseInt(element)*1000; }).sort((a, b) => a - b);
    var sheets = Math.ceil(lntha/(noptions[0]+10))*apex;
    var lstvidx = 0;
    var sizeb = boptions[boptions.length-1];
    for (let b = 0; b < boptions.length; b++) {
      if(lnthb <= boptions[b]){
        sizeb = boptions[b];
        break;
      }
    }
    for (let v = 0; v < products1[p]['variants'].length; v++) {
      if(products1[p]['variants'][v]['title'] == noptions[0]+'mm / '+sizeb+'mm'){
        lstvidx = v
      }
    }
    newcart.push({"sno":"PRODUCT1", "quantity":sheets, "product":products1[p]['id'], "title":products1[p]['variants'][lstvidx]['title'], "variant":products1[p]['variants'][lstvidx]['vid'], "sku":products1[p]['variants'][lstvidx]['sku'], "class":"COLOUR", "tag":1});
  }
  
  for(let p = 0; p < products2.length; p++){
    var lthoption = [];
    var ttl = '';
    var tgstr = JSON.stringify(products2[p]['tags']);
    var apex = 1;
    if(tag1 == 'Apex – Free Standing' || tag1 == 'Apex – Lean To'){ apex = 2; }
    if(tgstr.indexOf('PRODUCT') > 0){ ttl = tgstr.substring(tgstr.indexOf('PRODUCT'), tgstr.indexOf('PRODUCT')+9).replace(' ','') }
    if(ttl == 'PRODUCT2'){
      let noptions = products2[p]['options'][1]['values'].toString().replaceAll('m','').replaceAll(' ','').split(',').sort();
      noptions = noptions.map(function(element) { if(element > 20){ return parseFloat(element); } return parseFloat(element)*1000; }).sort((a, b) => a - b);
      var idx = noptions[noptions.length-1];
      for (let j = 0; j < noptions.length; j++) {
        if(lnthb <= noptions[j]){ idx = Number(noptions[j]/1000).toFixed(1); break; }
      }
      var title = colour2 + ' / '+idx+'m / 45mm Std Rafter Gasket';
      for (let v = 0; v < products2[p]['variants'].length; v++) {
        if (products2[p]['variants'][v]['title'] == title) {
          newcart.push({"sno":"PRODUCT2", "quantity":sheets-apex, "product":products2[p]['id'], "title":products2[p]['variants'][v]['title'], "variant":products2[p]['variants'][v]['vid'], "sku":products2[p]['variants'][v]['sku'], "class":"WIDTH", "tag":2});
          break;
        }
      }
      // newcart.push({"sno":"PRODUCT2", "quantity":sheets-apex, "product":products2[p]['id'], "title":products2[p]['variants'][idx]['title'], "variant":products2[p]['variants'][idx]['vid'], "sku":products2[p]['variants'][idx]['sku'], "class":"WIDTH", "tag":2});
    }
    if(ttl == 'PRODUCT3'){
      qty3 = 2;
      if(tag1 == 'Apex – Free Standing'){ qty3 = 4; }
      if(tag1 == 'Single Slope – Lean To Against Back and Side Wall'){ qty3 = 1; }
      let noptions = products2[p]['options'][1]['values'].toString().replaceAll('m','').replaceAll(' ','').split(',').sort();
      noptions = noptions.map(function(element) { if(element > 20){ return parseFloat(element); } return parseFloat(element)*1000; }).sort((a, b) => a - b);
      var idx = noptions[noptions.length-1];
      for (let j = 0; j < noptions.length; j++) {
        if(lnthb <= noptions[j]){ idx = Number(noptions[j]/1000).toFixed(1); break; }
      }
      var title = colour2 + ' / '+idx+'m / 45mm Std Rafter Gasket';
      for (let v = 0; v < products2[p]['variants'].length; v++) {
        if (products2[p]['variants'][v]['title'] == title) {
          newcart.push({"sno":"PRODUCT3", "quantity":qty3, "product":products2[p]['id'], "title":products2[p]['variants'][v]['title'], "variant":products2[p]['variants'][v]['vid'], "sku":products2[p]['variants'][v]['sku'], "class":"WIDTH", "tag":2});
          break;
        }
      }
      // newcart.push({"sno":"PRODUCT3", "quantity":qty3, "product":products2[p]['id'], "title":products2[p]['variants'][idx]['title'], "variant":products2[p]['variants'][idx]['vid'], "sku":products2[p]['variants'][idx]['sku'], "class":"WIDTH", "tag":2});
    }
    if(ttl == 'PRODUCT4'){
       qty4 = 1;
      if(tag1 == 'Apex – Lean To'){ qty4 = 2; }
      let noptions = products2[p]['options'][1]['values'].toString().replaceAll('m','').replaceAll(' ','').split(',').sort();
      noptions = noptions.map(function(element) { if(element > 20){ return parseFloat(element); } return parseFloat(element)*1000; }).sort((a, b) => a - b);
      var idx = noptions[noptions.length-1];
      for (let j = 0; j < noptions.length; j++) {
        if(lnthb <= noptions[j]){ idx = Number(noptions[j]/1000).toFixed(1); break; }
      }
      var title = colour2 + ' / '+idx+'m / 45mm Std Rafter Gasket';
      for (let v = 0; v < products2[p]['variants'].length; v++) {
        if (products2[p]['variants'][v]['title'] == title) {
          newcart.push({"sno":"PRODUCT4", "quantity":qty4, "product":products2[p]['id'], "title":products2[p]['variants'][v]['title'], "variant":products2[p]['variants'][v]['vid'], "sku":products2[p]['variants'][v]['sku'], "class":"WIDTH", "tag":2});
          break;
        }
      }
      // newcart.push({"sno":"PRODUCT4", "quantity":qty4, "product":products2[p]['id'], "title":products2[p]['variants'][idx]['title'], "variant":products2[p]['variants'][idx]['vid'], "sku":products2[p]['variants'][idx]['sku'], "class":"WIDTH", "tag":2});
    }
    for(let opt = 0; opt < products2[p]['options'].length; opt++){
      if(ttl == 'PRODUCT5' && products2[p]['options'][opt]['name'] == 'LENGTH'){
        var pqty = 1;
        let noptions = products2[p]['options'][1]['values'].toString().replaceAll('m','').replaceAll(' ','').split(',').sort();
    	  noptions = noptions.map(function(element) { if(element > 20){ return parseInt(element); } return parseInt(element)*1000; }).sort((a, b) => a - b);
        var idx = noptions[noptions.length-1];
        console.log(idx, lntha);
        if (idx <= lntha) {
          var title = colour2 + ' / '+Number(idx/1000).toFixed(1)+'m';
          for (let v = 0; v < products2[p]['variants'].length; v++) {
            if (products2[p]['variants'][v]['title'] == title) {
              newcart.push({"sno":"PRODUCT5", "quantity":parseInt(lntha/idx), "product":products2[p]['id'], "title":products2[p]['variants'][v]['title'], "variant":products2[p]['variants'][v]['vid'], "sku":products2[p]['variants'][v]['sku'], "class":"WIDTH", "tag":2});
              break;
            }
          }
          // newcart.push({"sno":"PRODUCT5", "quantity":parseInt(lntha/noptions[idx]), "product":products2[p]['id'], "title":products2[p]['variants'][idx]['title'], "variant":products2[p]['variants'][idx]['vid'], "sku":products2[p]['variants'][idx]['sku'], "class":"WIDTH", "tag":2});
        }
        for (let j = 0; j < noptions.length; j++) {
          if(lntha%idx > 0 && lntha%idx <= noptions[j]){
            var title = colour2 + ' / '+Number(noptions[j]/1000).toFixed(1)+'m';
            console.log(idx, lntha, title);
            for (let v = 0; v < products2[p]['variants'].length; v++) {
              if (products2[p]['variants'][v]['title'] == title) {
                newcart.push({"sno":"PRODUCT5", "quantity":pqty, "product":products2[p]['id'], "title":products2[p]['variants'][v]['title'], "variant":products2[p]['variants'][v]['vid'], "sku":products2[p]['variants'][v]['sku'], "class":"WIDTH", "tag":2});
                break;
              }
            }
            // newcart.push({"sno":"PRODUCT5", "quantity":pqty, "product":products2[p]['id'], "title":products2[p]['variants'][idx]['title'], "variant":products2[p]['variants'][idx]['vid'], "sku":products2[p]['variants'][idx]['sku'], "class":"WIDTH", "tag":2});
            break;
          }
        }
      }
      if(ttl == 'PRODUCT6'){
        var qt6 = 1;
        if(tag1 == 'Single Slope – Lean To Against Back Wall'){
        	qt6 = parseInt((lntha)/10000);
        	if((lntha)%10000 != 0){ qt6 += 1; }
        }
        if(tag1 == 'Single Slope – Lean To Against Back and Side Wall'){
        	qt6 = parseInt((lntha+lnthb)/10000);
        	if((lntha+lnthb)%10000 != 0){ qt6 += 1; }
        }
        if(tag1 == 'Apex – Lean To'){
        	qt6 = parseInt((lnthb*2)/10000);
        	if((lnthb*2)%10000 != 0){ qt6 += 1; }
        }
        
        $('.products .PRODUCT6 input').val(qt6);
        newcart.push({"sno":"PRODUCT6", "quantity":qt6, "product":products2[p]['id'], "title":products2[p]['variants'][0]['title'], "variant":products2[p]['variants'][0]['vid'], "sku":products2[p]['variants'][0]['sku'], "class":"WIDTH", "tag":2});
      }
      if(ttl == 'PRODUCT7' && products2[p]['options'][opt]['name'] == 'LENGTH'){
        var qt7 = 1;
        var apex = 1;
        if(tag1 == 'Apex – Free Standing' || tag1 == 'Apex – Lean To' || tag1 == 'Single Slope – Free Standing'){ apex = 2; }
        let noptions = products2[p]['options'][2]['values'].toString().replaceAll('m','').replaceAll(' ','').split(',').sort();
    	  noptions = noptions.map(function(element) { if(element > 20){ return parseFloat(element); } return parseFloat(element)*1000; }).sort((a, b) => a - b);
        var idx = noptions[noptions.length-1];
        if (idx < lntha) {
          var title = colour2 + ' / '+$('.thickness').val()+ ' / '+Number(idx/1000).toFixed(1)+'m';
          for (let v = 0; v < products2[p]['variants'].length; v++) {
            if (products2[p]['variants'][v]['title'] == title) {
              newcart.push({"sno":"PRODUCT7", "quantity":parseInt(lntha/idx)*apex, "product":products2[p]['id'], "title":products2[p]['variants'][v]['title'], "variant":products2[p]['variants'][v]['vid'], "sku":products2[p]['variants'][v]['sku'], "class":"WIDTH", "tag":2});
              break;
            }
          }
          // newcart.push({"sno":"PRODUCT5", "quantity":parseInt(lntha/noptions[idx]), "product":products2[p]['id'], "title":products2[p]['variants'][idx]['title'], "variant":products2[p]['variants'][idx]['vid'], "sku":products2[p]['variants'][idx]['sku'], "class":"WIDTH", "tag":2});
        }
        for (let j = 0; j < noptions.length; j++) {
          if(lntha%idx <= noptions[j]){
            var title = colour2 + ' / '+$('.thickness').val()+ ' / '+Number(noptions[j]/1000).toFixed(1)+'m';
            for (let v = 0; v < products2[p]['variants'].length; v++) {
              if (products2[p]['variants'][v]['title'] == title) {
                newcart.push({"sno":"PRODUCT7", "quantity":qt7*apex, "product":products2[p]['id'], "title":products2[p]['variants'][v]['title'], "variant":products2[p]['variants'][v]['vid'], "sku":products2[p]['variants'][v]['sku'], "class":"WIDTH", "tag":2});
                break;
              }
            }
            // newcart.push({"sno":"PRODUCT5", "quantity":pqty, "product":products2[p]['id'], "title":products2[p]['variants'][idx]['title'], "variant":products2[p]['variants'][idx]['vid'], "sku":products2[p]['variants'][idx]['sku'], "class":"WIDTH", "tag":2});
            break;
          }
        }
        
        // newcart.push({"sno":"PRODUCT7", "quantity":qt7, "product":products2[p]['id'], "title":products2[p]['variants'][idx]['title'], "variant":products2[p]['variants'][idx]['vid'], "sku":products2[p]['variants'][idx]['sku'], "class":"WIDTH", "tag":2});
      }
      if(ttl == 'PRODUCT8' && products2[p]['options'][opt]['name'] == 'LENGTH'){
        var qt8 = 1;
        let noptions = products2[p]['options'][1]['values'].toString().replaceAll('m','').replaceAll(' ','').split(',').sort();
    	  noptions = noptions.map(function(element) { if(element > 20){ return parseInt(element); } return parseInt(element)*1000; }).sort((a, b) => a - b);
        var idx = noptions[noptions.length-1];
        if (idx < lntha) {
          var title = colour2 + ' / '+Number(idx/1000).toFixed(1)+'m / 45mm Std Rafter Gasket';
          for (let v = 0; v < products2[p]['variants'].length; v++) {
            if (products2[p]['variants'][v]['title'] == title) {
              newcart.push({"sno":"PRODUCT8", "quantity":parseInt(lntha/idx), "product":products2[p]['id'], "title":products2[p]['variants'][v]['title'], "variant":products2[p]['variants'][v]['vid'], "sku":products2[p]['variants'][v]['sku'], "class":"WIDTH", "tag":2});
              break;
            }
          }
          // newcart.push({"sno":"PRODUCT8", "quantity":parseInt(lntha/noptions[idx]), "product":products2[p]['id'], "title":products2[p]['variants'][idx]['title'], "variant":products2[p]['variants'][idx]['vid'], "sku":products2[p]['variants'][idx]['sku'], "class":"WIDTH", "tag":2});
        }
        for (let j = 0; j < noptions.length; j++) {
          if(lntha%idx <= noptions[j]){
            var title = colour2 + ' / '+Number(noptions[j]/1000).toFixed(1)+'m / 45mm Std Rafter Gasket';
            for (let v = 0; v < products2[p]['variants'].length; v++) {
              if (products2[p]['variants'][v]['title'] == title) {
                newcart.push({"sno":"PRODUCT8", "quantity":qt8, "product":products2[p]['id'], "title":products2[p]['variants'][v]['title'], "variant":products2[p]['variants'][v]['vid'], "sku":products2[p]['variants'][v]['sku'], "class":"WIDTH", "tag":2});
                break;
              }
            }
            break;
          }
        }
      }
      if(ttl == 'PRODUCT9'){
        var qt9 = 2;
        if (tag1 == 'Apex – Lean To') {
          qt9 = 1;
        }
        for (let v = 0; v < products2[p]['variants'].length; v++) {
          if (products2[p]['variants'][v]['title'] == colour2) {
            newcart.push({"sno":"PRODUCT9", "quantity":qt9, "product":products2[p]['id'], "title":products2[p]['variants'][v]['title'], "variant":products2[p]['variants'][v]['vid'], "sku":products2[p]['variants'][v]['sku'], "class":"WIDTH", "tag":2});
            break;
          }
        }
        // newcart.push({"sno":"PRODUCT9", "quantity":qt9, "product":products2[p]['id'], "title":products2[p]['variants'][0]['title'], "variant":products2[p]['variants'][0]['vid'], "sku":products2[p]['variants'][0]['sku'], "class":"WIDTH", "tag":2});
      }
    }
    $('.products .'+products2[p]["id"]+' .total').html("");
    for(let v = 0; v < products2[p]['variants'].length; v++){
      for(let l = 0; l < lthoption.length; l++){
        if(lthoption.length > 0 && products2[p]['variants'][v]['title'] == colour2+' / '+lthoption[l]['length']){
          	$('.products .prod'+products2[p]["id"]+' .total').append("<p>SKU : <strong>"+products2[p]['variants'][v]['sku']+"</strong> Variant : "+products2[p]['variants'][v]['title']+' qty : '+lthoption[l]['quantity']+'</p>');
            newcart.push({"sno":ttl, "product":products2[p]['id'], "title":products2[p]['variants'][v]['title'], "variant":products2[p]['variants'][v]['vid'], "sku":products2[p]['variants'][v]['sku'], "quantity":lthoption[l]['quantity'], "class":"LENGTH "+ttl, "tag":2});
        }
      }
    }
  }
}

function clearCart(){
  	clrcart = 1;
  	newcart = [];
	$.ajax({
        type: "POST",
        url: '/cart/clear.js',
        data: '',
        dataType: 'json',
        success: function() { 
//             Shopify.clear();
          clrcart = 0;
        },
        error: function(XMLHttpRequest, textStatus) {
          clrcart = 0;
          console.log("Clear Cart Error");
          /* error code */
        }
      });
}